
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContainer as ObiContainerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-container.js';
 
 
 

 
 export const ObiContainer = createComponent({
   react: React,
   tagName: 'obi-container',
   elementClass: ObiContainerElement,
   events: {
     
   }
  });
 
 